import { Route } from 'src/routes/Route'

export const PricingRoute = Route({
  path: '/pricing',
  init: () => ({}),
  fromPath: () => ({}),
})
export type PricingRoute = Route<typeof PricingRoute>
